var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse",class:{ 'collapse--visible': _vm.visible },style:({ height: (_vm.collapseHeight + "px") })},[_c('div',{ref:"clickable",staticClass:"collapse__click",on:{"click":_vm.toggle}},[_vm._t("clickable")],2),_vm._v(" "),_c('div',{ref:"hidden",staticClass:"collapse__hidden"},[_vm._t("hidden")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8cf7c36","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collapse.vue
// module id = null
// module chunks = 